// extracted by css-extract-rspack-plugin
export default {"container":"container-ZSLGqv","svg":"svg-Yf4bzb","labelAnchor":"labelAnchor-WeD_j7","label":"label-cNxP6P"};